/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2022 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { useMemo } from 'react';
import getEnv from '../../casing/env';

export function useOmega(pageHeirarchy, pageName) {
  const env = useMemo(() => getEnv(), [getEnv]);

  if (!Object.prototype.hasOwnProperty.call(window, 'digitalData')) {
    window.digitalData = {};
  }

  const { digitalData } = window;

  digitalData.page = {
    autoTrack: false,
    env,
    hierarchy: pageHeirarchy,
    name: pageName,
    solution: {
      name: 'griffon',
      version: '0.0.1'
    }
  };
}
